















import {Mixins, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import authorityPopupContentTop from '@/components/authority/authorityPopupContentTop.vue';
import groupsPopupColumns from '@/components/authority/mixins/groupsPopupColumns';
import {i18nInObjectList} from '@/utils/i18n';
import {addClass, removeClass} from '@/utils/classUtils';
import TuiGrid from 'tui-grid';
@Component({
  components: {
    PageTitle,
    ItemTable,
    authorityPopupContentTop
  }
})
export default class GroupPopup extends Mixins(groupsPopupColumns) {
  private totalCount: any = 0;
  private option: any = {
    havePageSizeBtn: false,
    haveExcelDownBtn: false,
    autoHeight: true
  };
  private gridProps: any = {
    options: {
      header: {
        height: 32,
        bacground: '#ccc'
      },
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      displayRowCount: 30,
      havePageSizeBtn: false,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    columnOptions: {
      useFormattedValue: true
    },
    showDummyRows: true,
    columns: []
  };

  private listColumns: any = ['운영자명', '직급', '소속부서', '직책', '권한 등록일시'];
  private request: any = {
    pathParams: {
      authorityGroupNo: 0
    },
    params: {
      page: 1,
      pageSize: 20,
      adminName: ''
    }
  };
  private groupsListContent: any = {};

  private created(): void {
    this.initGrids();
    TuiGrid.setLanguage('ko', {
      display: {
        noData: this.$t('AUTHORITY_GROUPLIST_NO_SEARCH_RESULTS') as string
      }
    });
  }
  private initGrids(): void {
    this.listColumns.forEach((item: any) => {
      let key: any;
      for (key in this.GroupsPopupColumns) {
        if (item === key) {
          this.gridProps.columns.push(this.GroupsPopupColumns[key]);
        }
      }
    });
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridProps.options.rowHeaders = [{type: 'rowNum', minWidth: 60}];
  }
  private handleRequest(data: any): void {
    this.request.params.adminName = data;
    this.request.pathParams.authorityGroupNo = this.$route.query.authorityGroupNo;
    this.$api.getAuthorityGroupsAdminsByGroupNo(this.request).then((res: any) => {
      this.totalCount = res.data.totalCount;
      this.groupsListContent = res.data.contents;
    });
  }
  private mounted() {
    addClass(document.body, 'popup_medium');
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_medium');
  }
}
